// Trusted local churches, approved by BCM leadership.
//
// LOGOS: use only the official artwork supplied by BCM or taken from the
// church's own official site. Never generate, redraw, approximate, or recolor a
// church logo. Paste the hosted URL into `logo` and the card swaps its labeled
// asset slot for the real mark, preserving the original proportions.
//
// Do not add addresses, service times, descriptions, denominational claims,
// distances, or transportation details unless BCM explicitly requests them.

export type LocalChurch = {
  id: string
  name: string
  website: string
  /** Hosted URL of the official church logo, used exactly as supplied. */
  logo?: string
  /**
   * Set when the supplied file is a white-on-transparent (knockout) version.
   * The card inverts its tone so the mark is visible on a light background —
   * the artwork itself is unchanged, and no hue is introduced.
   */
  invertLogo?: boolean
}

export const localChurches: LocalChurch[] = [
  {
    id: 'crosslife',
    name: 'CrossLife Church',
    website: 'https://crosslifechurch.com/',
    // Supplied as a white-on-transparent knockout, so it is inverted to read on
    // the light card. Remove `invertLogo` if a dark version is supplied later.
    logo: 'https://cdn.magicpatterns.com/uploads/uxfTWudZLUWTcR5FTyeTkL/crosslife.svg',
    invertLogo: true,
  },
  {
    id: 'aloma',
    name: 'Aloma Church',
    website: 'https://www.alomachurch.org/',
    logo: 'https://cdn.magicpatterns.com/uploads/gYUqEUL7fVZj4gZ3TYWegR/Aloma.png',
  },
  {
    id: 'fbc-longwood',
    name: 'First Baptist Church Longwood',
    website: 'https://www.fbclongwood.org/',
    // NOTE: supplied as a JPG with black letterbox bars. A transparent PNG or
    // SVG would sit more cleanly on the card.
    logo: 'https://cdn.magicpatterns.com/uploads/sMp9xEjAFVwR84ot6TYbgZ/longggg.jpg',
  },
  {
    id: 'ubc-campus-hispano',
    name: 'University Baptist Church — Campus Hispano',
    website: 'https://ubcorlando.com/campus-hispano/',
    logo: 'https://cdn.magicpatterns.com/uploads/2fKQiq4iZf9JSsCPBGm4Um/UBC.png',
  },
  {
    id: 'genesis-orlando',
    name: 'Genesis Church Orlando',
    website: 'https://www.genesischurchorlando.com/',
    logo: 'https://cdn.magicpatterns.com/uploads/finXVL3sMR6xvSyapaYZwb/Genesis.png',
  },
  {
    id: 'church-at-the-cross',
    name: 'Church at the Cross',
    website: 'https://catcorlando.com/',
    logo: 'https://cdn.magicpatterns.com/uploads/xdv79zb6ADk2r89fCE2Ewv/avatar.3.png',
  },
  {
    id: 'pursuit',
    name: 'Pursuit Church',
    website: 'https://pursuitorlando.com/',
    logo: 'https://cdn.magicpatterns.com/uploads/tBTcwDFYYPRMn6G5RhJqLF/Pursuit.png',
  },
]
